<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  disabled?: boolean;
  loading?: boolean;
  error?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  loading: false,
  error: false,
});

const emit = defineEmits<{
  (e: 'click'): void;
}>();

const buttonText = computed(() => {
  if (props.loading) return 'Posting...';
  else if (props.error) return 'Error';
  else return 'Tweet';
});
</script>

<template>
  <div>
    <button
      class="uk-button twitter-button uk-flex uk-flex-center uk-flex-middle uk-border-pill uk-light"
      :class="{
        loading: loading,
        error: error,
      }"
      :disabled="disabled || loading"
      @click.stop="emit('click')"
    >
      <span uk-icon="twitter"></span>
      <span class="uk-margin-small-left uk-text-capitalize uk-text-bold">{{ buttonText }}</span>
    </button>
  </div>
</template>

<style lang="scss">
.twitter-button {
  background: #00acee;
  cursor: pointer;

  &.error {
    background: red;
  }

  &:hover {
    background: #007bac;
  }

  &:disabled {
    background: gray;
  }
}
</style>
